module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// C:/GH/1106/advice.noa.origination/~/readable-stream/transform.js
// module id = 390
// module chunks = 0